window.hscycle = {
    debounce, // 防抖
    throttle, // 节流
    accordion, // faq折叠函数
}

// 防抖函数
function debounce(fn, delay = 300) {
  let timer = null;

  return function (...args) {
    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

// 节流函数
function throttle(fn, delay = 300) {
  let timer = null;
  let lastTime = 0;  

  return function (...args) {
    const now = Date.now();
    if (now - lastTime >= delay) {
      fn.apply(this, args);
      lastTime = now;
    } else {
      if (timer) clearTimeout(timer);

      timer = setTimeout(() => {
        fn.apply(this, args);
        lastTime = Date.now();
        timer = null;
      }, delay - (now - lastTime));
    }
  };
}

/**
 * 初始化 Accordion（折叠面板）
 * @param {string} accordionSelector - 触发按钮的选择器，默认 '.hs-accordion'
 * @param {Object} options - 可选配置
 * @param {string} options.panelSelector - 面板选择器（相对触发器），默认 'nextElementSibling'
 * @param {string} options.iconSelector - 图标元素选择器，默认 '.hs-toggle-icon'
 * @param {string} options.activeIconAttr - 展开时文字属性，默认 'data-icon-active'
 * @param {string} options.inactiveIconAttr - 收起时文字属性，默认 'data-icon-inactive'
 * @param {boolean|number|number[]|Function} options.defaultOpen - 初始展开配置
 * 
 * // 全部展开
 * accordion('.hs-accordion', { defaultOpen: true });
 * 
 * // 只展开第 1 个（索引 0）
 * accordion('.hs-accordion', { defaultOpen: 0 });
 * 
 * // 展开第 1 个和第 3 个
 * accordion('.hs-accordion', { defaultOpen: [0, 2] });
 * 
 * // 按条件展开，比如 data-default="true" 的按钮
 * accordion('.hs-accordion', {
 *   defaultOpen: (btn) => btn.dataset.default === 'true',
 * });
 * 
 */
function accordion(
  accordionSelector = '.hs-accordion',
  options = {}
) {
  const {
    panelSelector = 'nextElementSibling',
    accordionItemSelector = '.hs-accordion-item',
    defaultOpen = false,
  } = options;

  // 获取所有 accordion 按钮
  const accButtons = document.querySelectorAll(accordionSelector);

  // 提取面板查找逻辑，避免重复
  function getPanel(btn) {
    if (typeof panelSelector === 'string') {
      if (panelSelector === 'nextElementSibling') {
        return btn.nextElementSibling;
      } else if (accordionItemSelector) {
        return btn.closest(accordionItemSelector)?.querySelector(panelSelector);
      } else {
        return btn.querySelector(panelSelector) || btn.nextElementSibling;
      }
    } else if (panelSelector instanceof Function) {
      return panelSelector(btn);
    }
    return null;
  }

  // 提取点击处理逻辑为具名函数
  function handleClick() {
    // 切换 active 类
    this.classList.toggle('active');
    // 获取对应的 panel
    const panel = getPanel(this);

    if (!panel) return;

    // 处理面板展开/收起
    if (panel.style.maxHeight && panel.style.maxHeight !== '0px') {
      panel.style.maxHeight = '0px'; // 收起
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px'; // 展开
      setParentHeight(panel);
    }
  }

  // 初始化时处理默认展开
  accButtons.forEach((btn, index) => {
    const panel = getPanel(btn);
    if (!panel) return;

    let shouldOpen = false;

    if (typeof defaultOpen === 'boolean') {
      shouldOpen = defaultOpen;
    } else if (typeof defaultOpen === 'number') {
      shouldOpen = index === defaultOpen;
    } else if (Array.isArray(defaultOpen)) {
      shouldOpen = defaultOpen.includes(index);
    } else if (typeof defaultOpen === 'function') {
      shouldOpen = defaultOpen(btn, index);
    }

    // 如果 HTML 上已经手动写了 active 类，也保持展开
    if (btn.classList.contains('active')) {
      shouldOpen = true;
    }

    if (shouldOpen) {
      btn.classList.add('active');
      panel.style.maxHeight = panel.scrollHeight + 'px';
      setParentHeight(panel);
    } else {
      btn.classList.remove('active');
      panel.style.maxHeight = '0px';
    }
  });

  // 绑定事件
  accButtons.forEach((btn) => {
    btn.addEventListener('click', handleClick);
  });

  // 返回销毁方法
  return {
    destroy: function () {
      accButtons.forEach((btn) => {
        // 1. 移除点击事件监听
        btn.removeEventListener('click', handleClick);

        // 2. 移除 active 状态类
        btn.classList.remove('active');

        // 3. 找到对应的面板并清除内联样式
        const panel = getPanel(btn);

        if (panel) {
          // 核心修改：使用 removeProperty 清除内联的 max-height，让 CSS 接管
          panel.style.removeProperty('max-height');
        }
      });

      // 4. 清除父级容器的内联 maxHeight（如果有的话）
      document.querySelectorAll('[data-hs-panel]').forEach((p) => {
        p.style.removeProperty('max-height');
      });
    },
  };
}

// 设置父级容器高度
function setParentHeight(panel) {
  var updom = panel.parentElement.closest('[data-hs-panel]');
  var curPanelHeight = panel.scrollHeight;
  var level = 0;
  while (updom && level < 3) {
    updom.style.maxHeight = updom.scrollHeight + curPanelHeight + 'px';
    updom = updom.parentElement.closest('[data-hs-panel]');
    level++;
  }
}





// 获取本土URL
function localUrl(path) {
    if (typeof path !== "undefined" && path != null && path.trim() !== "") {
        const trimmedPath = path.replace(/^\/+/, '')
        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
            return window.Shopify.routes.root + trimmedPath;
        } else {
            return '/' + trimmedPath;
        }
    } else {
        return '/'
    }
}

// 统一的 fetch API 方法，返回 Promise
function fetchApi(url, options = {}) {
    if(!url) return
    return fetch(localUrl(url), options).then(res=> {
        const contentType = res.headers.get('content-type') || '';
        const isJsonType = contentType.includes('application/json') || contentType.includes('text/json') || contentType.includes('text/javascript');
        if(res.ok) {
            // 统一处理成功响应
            const parsePromise = isJsonType ? res.json() : res.text();
            return parsePromise.then(function (data) {
                document.dispatchEvent(new CustomEvent('fetch:api:success', { detail: { data } }));
                return data;
            });
        } else {
            if(res.status == 429) {
                window.location.reload();
                throw new Error('Too Many Requests');
            } else {
                if (isJsonType) {
                    return res.json().then((data) => {
                        const message = (data && (data.description || data.message)) || `Request failed with status ${res.status}`;
                        const error = new Error(message);
                        error.status = res.status;
                        error.data = data;
                        throw error;
                    });
                }
            }
        }
    }).catch(err => {
        document.dispatchEvent(new CustomEvent('fetch:api:error', { detail: { data: err } }));
        throw err;
    }).finally(() => {
        document.dispatchEvent(new CustomEvent('fetch:api:done'));
    });
}



// ---------------------------------------------------------------------- 
// 统一的 fetch api 事件监听
// 请求成功
document.addEventListener('fetch:api:success', function(e) {
    console.log('fetch:api:success');
})

// 请求失败
document.addEventListener('fetch:api:error', function(e) {
  console.error('fetch:api:error');
  if(window.hsToast) {
    if(e.detail && e.detail.data && e.detail.data.message) {
      window.hsToast('warning', e.detail.data.message);
    } else {
      window.hsToast('error', 'Request failed. Please try again.');
    }
  }
})

// 请求结束
document.addEventListener('fetch:api:done', function(e) {
    console.log('fetch:api:done');
})
// ---------------------------------------------------------------------- 



// ---------------------------------------------------------------------- 

// 获取购物车数量
function fetchCartCountFn() {
  return fetchApi('cart.js', {
    credentials: 'same-origin'
  }).then(res => res.item_count ? res.item_count : -1)
}

// 清空购物车
function clearCartFn() {
  return fetchApi('cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }).then(res => res)
}


// 增减购物车商品数量
function changeCartLineDataFn(line, quantity) {
  return fetchApi('cart/change.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity,
      sections: ['cart-form-tmp'],
      sections_url: localUrl()
    })
  }).then(function (res) {
      if (res && res.item_count === 0) {
        window.location.reload();
        return;
      }
      return res;
    })
    .catch(function (error) {
      throw error;
    });
}

// 获取指定 section 的 HTML 内容
function fetchSectionFn(productUrl, sectionId) {
  var url = productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'sections=' + encodeURIComponent(sectionId);
  return fetchApi(url)
  .then(function(data) {
      var html = data[sectionId];
      if (!html) {
        var error = new Error('Section HTML not found in response');
        error.code = 'NO_SECTION_HTML';
        error.sectionId = sectionId;
        throw error;
      }
      return html;
    })
};

// 获取购物车section
function fetchCartViewFn() {
  return fetchApi('cart?section_id=cart-form-wrap', {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(res => {
    return res
  }).catch(err => {
    window.location.href = localUrl('cart');
  })
}


// 加入购物车
function submitAtcFn(data) {
  if(!data) return Promise.reject(new Error('Data is required'));
  const formData = new FormData(data);
  formData.append('sections', 'cart-count,cart-form-wrap');
  formData.append('sections_url', localUrl(''));
  document.dispatchEvent(new CustomEvent('hs:cart:add:start'));
  return fetchApi('cart/add.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    body: formData
  })
  .then(res => {
    document.dispatchEvent(new CustomEvent('hs:cart:add:success', {
      detail: {
        message: data.successMessage || null,
        data: res,
      }
    }));
    return res;
  })
  .catch(err => {
    document.dispatchEvent(new CustomEvent('hs:cart:add:fail', {
      detail: { message: data.errorMessage || null }
    }));
    return err
  })
  .finally(() => {
    // 全局 loading 结束
    document.dispatchEvent(new CustomEvent('hs:cart:add:done'));
  });
}

// 更新购物车信息
function updateCartInfoFn(data) {
  if(!data) return Promise.reject(new Error('Data is required'));
  data.sections = 'cart-form-tmp';
  return fetchApi('cart/update.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(function (res) {
      document.dispatchEvent(new CustomEvent('hs:cart:update:success', {
        detail: {
          message: data.successMessage || null,
          data: res,
        }
      }));
      console.log('Cart Info updated');
      return res
  }).catch(err => {
    document.dispatchEvent(new CustomEvent('hs:cart:update:fail', {
      detail: {
        message: data.errorMessage || null,
        data: err,
      }
    }));
    throw err;
  })
}



// -----------------------------------------------------------------------------------

// 解析HTML字符串为DOM文档
function parseHtmlString(htmlString) {
  if (!htmlString) return null
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  return doc
}


// 初始化购物车方法
function initHsCart(root) {
  if (!root || !(root instanceof Element)) return;
  const cartBox = root.querySelector('[data-hs-cart-form]');
  if (!cartBox) return;
  cartBox.dataset.hsCartInited = 'true';

  // 
  function afterFn(e, dom) {
    if(e && e.item_count != null) {
      updateCartIconCount(e.item_count);
    }
    dom.classList.toggle('active', false);
  }

  function beforeFn(dom) {
    dom.classList.toggle('active', true);
  }

  cartBox.addEventListener('click', function (event) {
    const minusBtn = event.target.closest('[data-qty-minus]');
    const plusBtn = event.target.closest('[data-qty-plus]');
    const removeBtn = event.target.closest('[data-remove-line]');
    const row = event.target.closest('[data-line]');
    if (!row) return;
    const key = row.dataset.line;
    const qtyInput = row.querySelector('[data-cart-quantity-input]');
    if (!qtyInput) return;

    let currentQty = parseInt(qtyInput.value, 10) || 0;

    if (minusBtn) {
      const step = parseFloat(qtyInput.step) || 1;
      // 先把目标数量算出来，允许到 0
      const rawNewQty = Math.max(currentQty - step, 0);
      // 再按规则对齐，但允许 0 直接返回 0（用于删除行）
      const newQty = alignToInputRules(qtyInput, rawNewQty, { allowZero: true });
      beforeFn(minusBtn);
      changeCartLineDataFn(key, newQty).then(function (res) {
        replaceCartFormSection(res, cartBox)
        afterFn(res, minusBtn);
      }).catch(function(res) {
        afterFn(null, minusBtn);
      });
      return;
    }

    if (plusBtn) {
      const step = parseFloat(qtyInput.step) || 1;
      const rawNewQty = currentQty + step;
      const newQty = alignToInputRules(qtyInput, rawNewQty);
      beforeFn(plusBtn);
      changeCartLineDataFn(key, newQty).then(function (res) {
        replaceCartFormSection(res, cartBox)
        afterFn(res, plusBtn);
      }).catch(function(res) {
        afterFn(null, plusBtn);
      });
      return;
    }

    if (removeBtn) {
      beforeFn(removeBtn);
      changeCartLineDataFn(key, 0).then(function (res) {
        replaceCartFormSection(res, cartBox)
        afterFn(res, removeBtn);
      }).catch(function(res) {
        afterFn(null, removeBtn);
      });
      return;
    }
  });

  cartBox.addEventListener('change', function (event) {
    const input = event.target.closest('[data-cart-quantity-input]');
    if (!input) return;

    const row = input.closest('[data-line]');
    if (!row) return;

    const key = row.dataset.line;

    // 原始输入值
    const rawValue = input.value;

    // 对齐数量规则：允许 0（删除）
    const alignedQty = alignToInputRules(input, rawValue, { allowZero: true });

    // 同步回 input，避免显示和实际提交不一致
    input.value = alignedQty;

    changeCartLineDataFn(key, alignedQty).then(function (res) {
      replaceCartFormSection(res, cartBox);
    })
  })


  cartBox.addEventListener('blur', function (event) {
    const textarea = event.target.closest('[data-cart-note]');
    if (!textarea) return;
    updateCartInfoFn({ note: textarea.value });
  }, true);

  cartBox.addEventListener('click', function (event) {
    const applyCouponBtn = event.target.closest('[data-apply-coupon]');
    if (!applyCouponBtn) return;
    const couponCode = applyCouponBtn.parentElement.querySelector('[name="coupon_code"]');
    if (!couponCode || !couponCode.value) return;
    beforeFn(applyCouponBtn);
    updateCartInfoFn({ discount: couponCode.value, successMessage: applyCouponBtn.dataset.couponSuccessMsg, errorMessage: applyCouponBtn.dataset.couponFailMsg }).then(function (res) {
      replaceCartFormSection(res, cartBox);
    }).finally(function() {
      afterFn(null, applyCouponBtn);
    });
  }, true);

  document.dispatchEvent(new CustomEvent('hs:cart:initialized'))
}

// 替换购物车表单内容
function replaceCartFormSection(res, cartBox) {
  const section = res?.sections?.['cart-form-tmp'];
  if (!section || !cartBox) return;
  const doc = parseHtmlString(section);
  if (!doc || !doc.querySelector) return
  const formDom = doc.querySelector('[data-hs-cart-form]');
  if (!formDom) return;
  cartBox.innerHTML = formDom.outerHTML;
  document.dispatchEvent(new CustomEvent('hs:cart:refreshed'));
}

// 监听初始化购物车事件
document.addEventListener('hs:cart:initialized', function() {
  if (window.hscycle && typeof window.hscycle.accordion === 'function') {
    window.hscycle.accordion('[hs-cart-acd]');
  }
})
// 购物车内容替换成功
document.addEventListener('hs:cart:refreshed', function() {
  if (window.hscycle && typeof window.hscycle.accordion === 'function') {
    window.hscycle.accordion('[hs-cart-acd]');
  }
})

// 购物车更新成功
document.addEventListener('hs:cart:update:success', function(data) {
  const { message = null } = data?.detail;
  if (!message) return;
  if (window.hsToast && typeof window.hsToast.success === 'function') {
    window.hsToast.success(message);
  }
})

// 购物车更新失败
document.addEventListener('hs:cart:update:fail', function(data) {
  const { message = null } = data?.detail;
  if (!message) return;
  if (window.hsToast && typeof window.hsToast.warning === 'function') {
    window.hsToast.warning(message);
  }
})



// 纯函数：根据 min / max / step 对一个给定值进行对齐
function alignQuantity(value, min, max, step, options = {}) {
  const { allowZero = false } = options;

  const safeMin = typeof min === 'number' && !isNaN(min) ? min : 1;
  const safeStep = typeof step === 'number' && !isNaN(step) && step > 0 ? step : 1;
  const safeMax = typeof max === 'number' && !isNaN(max) ? max : Infinity;

  let newValue = parseFloat(value);

  // 1. 处理 NaN
  if (isNaN(newValue)) {
    newValue = safeMin;
  }

  // 特殊处理：允许 0 的场景
  if (allowZero && newValue <= 0) {
    // 这里直接返回 0，不再按 min/step 对齐
    return 0;
  }

  // 2. clamp 到 [min, max] 范围
  if (newValue < safeMin) newValue = safeMin;
  if (newValue > safeMax) newValue = safeMax;

  // 3. 按 step 对齐（基于 min 偏移）
  const offset = newValue - safeMin;
  const remainder = offset % safeStep;

  if (remainder !== 0) {
    newValue = newValue - remainder;
    if (newValue < safeMin) {
      newValue = safeMin;
    }
  }

  return newValue;
}


// 对齐函数
function alignToInputRules(qtyInput, value, options = {}) {
  const min = parseFloat(qtyInput.min) || 1;
  const maxAttr = qtyInput.max;
  const max = maxAttr === '' || maxAttr === undefined ? Infinity : parseFloat(maxAttr);
  const step = parseFloat(qtyInput.step) || 1;

  return alignQuantity(value, min, max, step, options);
}



// 清空购物车方法（事件委托版）----------------------------------------------
document.addEventListener('click', function(e) {
  const targetBtn = e.target.closest('[data-hs-cart-clear-btn]'); // 点击的按钮
  if (!targetBtn) return;
  e.preventDefault();
  if (targetBtn.disabled) return; // 避免重复点击
  targetBtn.classList.toggle('active', true); // 显示加载状态
  targetBtn.disabled = true; // 禁用按钮, 避免重复点击

  const cartForm = document.querySelectorAll('[data-hs-cart-form]');
  if (!cartForm) return;
  
  // API 清空购物车
  clearCartFn() 
    .then(function () {
      cartForm.forEach((item) => {
        item.innerHTML =`<div class="hs-cart__item--empty">${targetBtn.dataset.emptyCartText || 'Your cart is empty'}</div>`;
      })
      document.dispatchEvent(new CustomEvent('hs:cart:cleared')) // 触发购物车清空事件
    })
    .catch(function (error) {
      if (window.hsToast) {
        window.hsToast('error', (error && error.message) || 'Failed to clear cart.');
      }
    })
    .finally(function () {
      targetBtn.classList.toggle('active', false); // 隐藏加载状态
      targetBtn.disabled = false; // 启用按钮
    });
})

// 更新导航栏购物车图标数量
function updateCartIconCount(count) {
  const cartIcon = document.querySelector('[data-cart-count-box]');
  if (!cartIcon) return;
  cartIcon.textContent = count;
}

// 监听购物车清空事件
document.addEventListener('hs:cart:cleared', function() {
  updateCartIconCount(0)
})
// ----------------------------------------------------------------


// 点击购物车按钮事件
document.addEventListener('hs:side:cart:click', function(data) {
  const { data: openCartBtn } = data?.detail || {};
  if (!openCartBtn) return;
    
  openCartBtn.classList.toggle('active', true)
    fetchCartViewFn()
      .then((html) => {
        window.hsPushbar.open('right')
        const activeElement = window.hsPushbar.activeElement;
        activeElement.innerHTML = html;
        document.dispatchEvent(new CustomEvent('hs:init:cart', { detail: { root: activeElement } }));
      })
      .catch((error) => {
        console.error('打开购物车失败:', error);
        window.location.href = localUrl('/cart');
      })
      .finally(() => {
        openCartBtn.classList.toggle('active', false)
      });
})

// 购物车加载完毕初始化购物车事件
document.addEventListener('hs:init:cart', function(data) {
  if (data && data.detail) {
    const root = data.detail.root || null
    if (!root) return;
    initHsCart(root)
  }
})



// ----------------------------------------------------------------
// 产品变体
// 变体选项改变,中间处理事件
document.addEventListener('hs:prod:var:option:change', function (data) {
  if (!data || !data.detail) return;

  const root = data.detail.root || null;
  const selectedData = data.detail.selectedData || null;
  const changedIndex = typeof data.detail.changedIndex === 'number'
    ? data.detail.changedIndex
    : -1; // 没传就从第 0 维开始

  if (!root || !selectedData) return;

  const variantsJsonArr = getVariantsJsonArr(root);
  if (!Array.isArray(variantsJsonArr) || variantsJsonArr.length === 0) return;

  // 1. 从 changedIndex 开始，自动修正后续维度非法选中
  const startIndex = changedIndex < 0 ? 0 : changedIndex;
  fixInvalidSelectionsFromIndex(root, variantsJsonArr, startIndex);

  // 2. 修正后重新从 DOM 读一次完整选择
  const completedSelectedData = readSelectedData(root);

  // 3. 用当前选择尝试找变体
  let selectedVariant = getSelectedVariant(variantsJsonArr, completedSelectedData);

  // 4. 如果没找到或变体不可售，走你的原兜底逻辑
  if (!selectedVariant || selectedVariant.available !== true) {
    // 先补全还没选过的维度（保留原逻辑，如果不需要可以删掉）
    autoCompleteSelection(root, variantsJsonArr);

    const completedAgain = readSelectedData(root);
    selectedVariant = getSelectedVariant(variantsJsonArr, completedAgain);

    if (!selectedVariant || selectedVariant.available !== true) {
      const firstDimInput = root.querySelector('input[data-hs-option-index="0"]:checked');
      const firstDimValue = firstDimInput ? firstDimInput.getAttribute('value') : null;

      if (firstDimValue) {
        const fallbackVariant = variantsJsonArr.find(variant => {
          return variant.available === true &&
                 Array.isArray(variant.options) &&
                 variant.options[0] === firstDimValue;
        });

        if (fallbackVariant) {
          setSelectedVariant(fallbackVariant, root);
          selectedVariant = fallbackVariant;
        }
      }
    }
  }

  document.dispatchEvent(
    new CustomEvent('hs:prod:var:changed', {
      detail: {
        selectedVariant,
        root,
      },
    }),
  );
});

// 从 DOM 读取当前各维度已选值
function readSelectedData(root) {
  const inputs = root.querySelectorAll('[data-hs-var-item]:checked');
  return Array.from(inputs).map((item) => ({
    name: item.getAttribute('name') || null,
    value: item.getAttribute('value') || null,
  }));
}

// 自动补全：根据当前已选高维，依次为后续维度选中第一个“未禁用”的选项
function autoCompleteSelection(root, variantsJsonArr) {
  if (!root || !Array.isArray(variantsJsonArr) || variantsJsonArr.length === 0) return;

  const firstOptions = variantsJsonArr[0].options;
  const optionCount = Array.isArray(firstOptions) ? firstOptions.length : 0;
  if (optionCount === 0) return;

  for (let i = 0; i < optionCount; i++) {
    const groupInputs = root.querySelectorAll(`input[data-hs-option-index="${i}"]`);
    if (!groupInputs.length) continue;

    const hasChecked = Array.from(groupInputs).some((input) => input.checked && !input.disabled);
    if (hasChecked) continue;

    // 当前组尚未有效选中：选中第一个可用的
    const firstEnabled = Array.from(groupInputs).find((input) => !input.disabled);
    if (firstEnabled) {
      firstEnabled.checked = true;
    }
  }
}

// 变体id改变,中间处理事件
document.addEventListener('hs:prod:var:id:change', function(data) {
  if (data && data.detail) {
    const root = data.detail.root || null
    const selectedData = data.detail.selectedData || null
    if (!root || !selectedData) return;
    const selectedVariant = getSelectVariantById(getVariantsJsonArr(root), selectedData)
    document.dispatchEvent(new CustomEvent('hs:prod:var:changed', {
        detail: {
            selectedVariant,
            root, 
        }
    }));
  }
})

// 变体改变完成,执行相关操作
document.addEventListener('hs:prod:var:changed', function(data) {
    if (!data || !data.detail) return;

    const selectedVariant = data.detail.selectedVariant || null;
    const root = data.detail.root || null;

    if (!selectedVariant || !root) return;

    // 1. 先同步按钮选中状态
    setSelectedVariant(selectedVariant, root);

    // 2. 再根据最新选中值刷新所有变体的可用状态
    refreshVar(selectedVariant, root);

    // 3. 更新其他商品信息
    setProdPrice(selectedVariant, root);
    setSubmitInput(selectedVariant, root);
    setInputMinMaxNum(selectedVariant, root);
    setMainProdImage(selectedVariant, root);
});

// 更新数量函数
function updateQty(root, newQty) {
  const qtyInputs = root.querySelectorAll('[data-hs-qty-input]');
  qtyInputs.forEach(input => {
    input.value = newQty;
  });
}


// 获取变体json数组
function getVariantsJsonArr(root) {
  if (!root) return null;

  const variantsCtr = root.querySelector('[data-hs-variants]');
  if (!variantsCtr) return null;

  try {
    const jsonString = variantsCtr.getAttribute('data-hs-variants');
    if (!jsonString) return null;

    // 防御性处理：去除首尾空白和可能存在的 BOM 头
    const cleanString = jsonString.trim().replace(/^\uFEFF/, '');
    if (!cleanString) return null;

    const data = JSON.parse(cleanString);


    return data;
  } catch (err) {
    // 捕获 SyntaxError，避免程序崩溃
    console.error('JSON 解析失败:', err);
    return null; // 返回一个安全的默认值
  }
}

// 通过变体id获取变体对象
function getSelectVariantById(variantsJsonArr, varId) {
    if(!variantsJsonArr || !varId) return null
    const selectedVariant = variantsJsonArr.find(variant => {
        if(variant.id && varId && variant.id == varId) return true
    });
    return selectedVariant
}


// 根据选中变体刷新各选项值的可用状态(禁用/启用)
// 规则: 某选项组内的某个值可用, 当且仅当存在一个 available 的变体,
// 其该组取此值, 且其它组均保持选中变体的当前值
// 根据当前已选的各维度值，刷新每个选项的可用状态（自上而下联动）
function refreshVar(selectedVariant, root) {
  if (!root) return;

  const variantsJsonArr = getVariantsJsonArr(root);
  if (!Array.isArray(variantsJsonArr) || variantsJsonArr.length === 0) return;

  const scope = root;
  const firstOptions = variantsJsonArr[0].options;
  const optionCount = Array.isArray(firstOptions) ? firstOptions.length : 0;
  if (optionCount === 0) return;

  // 读取当前各维度已选中的值（可能为 null）
  const selectedValues = [];
  for (let i = 0; i < optionCount; i++) {
    const checked = scope.querySelector(
      `input[data-hs-option-index="${i}"]:checked`
    );
    selectedValues[i] = checked ? checked.getAttribute('value') : null;
  }

  // 按维度依次刷新
  for (let i = 0; i < optionCount; i++) {
    const inputs = scope.querySelectorAll(
      `input[data-hs-option-index="${i}"]`
    );

    inputs.forEach((input) => {
      const value = input.getAttribute('value');

      const isAvailable = variantsJsonArr.some((variant) => {
        if (!Array.isArray(variant.options)) return false;

        // 当前维度必须等于该值
        if (variant.options[i] !== value) return false;

        // 只受「比当前维度更前面的维度」约束
        for (let j = 0; j < i; j++) {
          const sel = selectedValues[j];
          if (sel == null) continue; // 上游维度没选，就不限制
          if (variant.options[j] !== sel) return false;
        }

        return variant.available === true;
      });

      input.disabled = !isAvailable;
      if (isAvailable) {
        input.removeAttribute('aria-disabled');
      } else {
        input.setAttribute('aria-disabled', 'true');
      }
    });
  }
}

// 通过变体选项获取变体对象
function getSelectedVariant(variantsJsonArr, selectedData) {
    if (!Array.isArray(variantsJsonArr) || !Array.isArray(selectedData)) return null;
    // 找到匹配的变体对象
    return variantsJsonArr.find(variant => {
      return selectedData.every(selection => {
        if (!selection || typeof selection.name !== 'string') return false;
        const name = selection.name.split('-')[0]
        return variant[name] === selection.value;
      });
    }) || null;
}
    
// 设置选中的变体
// 遍历变体选项, 找到匹配的input, 并设置为checked中
function setSelectedVariant(selectedVariant, root) {
    if(selectedVariant && root) {
        selectedVariant.options.forEach((option, index) => {
            const targetVarInput = root.querySelector(`input[value="${option}"][data-hs-option-index="${index}"]`)
            if(targetVarInput) {
                targetVarInput.checked = true
            }
        })
    }
}

// 设置商品价格, 包含销售价格和对比价格
function setProdPrice(selectedVariant, root) {
    if(!selectedVariant || !root) return
    const priceEls = root.querySelectorAll('[data-hs-sale-price]')
    const comparePriceEls = root.querySelectorAll('[data-hs-regular-price]')
    const saveEls = root.querySelectorAll('[data-hs-save]')
    const variantId = selectedVariant.id
    if(variantId) {
        const tmpPriceEl = root.querySelector(`template[data-hs-var-id="${variantId}"]`)
        if(tmpPriceEl) {
            const salePrice = tmpPriceEl.getAttribute('data-hs-var-price')
            const comparePrice = tmpPriceEl.getAttribute('data-hs-compare-price')
            const save = tmpPriceEl.getAttribute('data-hs-save')
            if(priceEls.length > 0) {
                priceEls.forEach(priceEl => {
                    priceEl.innerHTML = salePrice
                })
            }
            if(comparePriceEls.length > 0) {
                comparePriceEls.forEach(comparePriceEl => {
                    if (comparePrice) {
                        comparePriceEl.innerHTML = comparePrice
                        comparePriceEl.hidden = false;
                    } else {
                        comparePriceEl.hidden = true;
                    }
                })
            } 
            if(saveEls.length > 0) {
                saveEls.forEach(saveEl => {
                    if (save) {
                        saveEl.innerHTML = save
                        saveEl.hidden = false;
                    } else {
                        saveEl.hidden = true;
                    }
                })
            }
        }
    }
}

// 设置提交input的值, value为变体id
function setSubmitInput(selectedVariant, root) {
    if(!selectedVariant || !root) return
    const variantInput = root.querySelector('[data-hs-var-id-input]');
    if(!variantInput) return
    const variantId = selectedVariant.id || null
    if(variantId) {
        variantInput.value = variantId;
    }
}
    
// 设置购买数量输入框的最小值、最大值和步进值
function setInputMinMaxNum(selectedVariant, root) {
  if (!selectedVariant || !root) return;

  const qtyRule = selectedVariant.quantity_rule;
  if (!qtyRule) return;

  const qtyInputs = root.querySelectorAll('[data-hs-qty-input]');
  if (!qtyInputs || qtyInputs.length === 0) return;

  qtyInputs.forEach((qtyInput) => {
    if (!qtyInput) return;

    const currentValue = parseFloat(qtyInput.value);

    // 1. 应用变体的数量规则到 input 属性
    let min, max, step;

    if (qtyRule.min != null && typeof qtyRule.min === 'number' && qtyRule.min >= 1) {
      min = qtyRule.min;
      qtyInput.min = qtyRule.min;
    } else {
      min = 1;
      qtyInput.min = 1;
    }

    if (qtyRule.max != null && typeof qtyRule.max === 'number' && qtyRule.max >= min) {
      max = qtyRule.max;
      qtyInput.max = qtyRule.max;
    } else {
      max = Infinity;
      qtyInput.removeAttribute('max');
    }

    if (qtyRule.increment != null && typeof qtyRule.increment === 'number' && qtyRule.increment >= 1) {
      step = qtyRule.increment;
      qtyInput.step = qtyRule.increment;
    } else {
      step = 1;
      qtyInput.step = 1;
    }

    // 2. 使用公共对齐函数修正当前 value
    const alignedValue = alignQuantity(currentValue, min, max, step);
    qtyInput.value = alignedValue;
  });
}





// -------------------------------------------------

// 购买数量输入框输入事件
document.addEventListener('hs:prod:qty:input', function(data) {
    if (!data || !data.detail) return;
    const qtyInput = data.detail.eventDom || null;
    const root = data.detail.root || null;
    if (!qtyInput || qtyInput.tagName.toLowerCase() !== 'input' || qtyInput.value == null) {
        return;
    }
    const qty = qtyInput.value;
    updateQty(root, alignToInputRules(qtyInput, qty));
});

// 点击购买数量按钮事件
document.addEventListener('hs:prod:qty:click', function (event) {
  const detail = event && event.detail;
  if (!detail) return;

  const root = detail.root || null;
  const qtyBox = detail.qtyBox || null;
  const eventDom = detail.eventDom || null;

  if (!qtyBox || !eventDom) return;
  if (eventDom.tagName.toLowerCase() !== 'button') return;

  const qtyInput = qtyBox.querySelector('[data-hs-qty-input]');
  if (!qtyInput) return;

  const btnType = eventDom.getAttribute('data-hs-qty-button-type');
  if (!btnType) return;

  const BUTTON_TYPE = {
    MINUS: 'minus',
    PLUS: 'plus',
  };

  const min = parseFloat(qtyInput.min) || 1;
  const step = parseFloat(qtyInput.step) || 1;
  const current = parseFloat(qtyInput.value || min);

  let qty = current;

  if (btnType === BUTTON_TYPE.MINUS) {
    // 按 step 减
    qty = current - step;
    // 对齐规则（包含 min / max / step）
    qty = alignToInputRules(qtyInput, qty);
    // 避免不断点击减号出现 0 或负数
    if (qty < min) qty = min;
  } else if (btnType === BUTTON_TYPE.PLUS) {
    // 按 step 加
    qty = current + step;
    // 对齐规则（包含 min / max / step）
    qty = alignToInputRules(qtyInput, qty);
  } else {
    // 未知类型，直接返回，避免未来扩展出现问题
    return;
  }

  updateQty(root, qty);
});


// ---------------------------------
// 点击添加到购物车按钮事件
document.addEventListener('hs:prod:atc:click', function (event) {
  if (!event || !event.detail) return;
  const atcBtn = event.detail.atcBtn || null;
  const root = event.detail.root || null;
  if (!atcBtn || !root) return;
  const form = root.querySelector('[data-hs-atc-form]');
  if (!form) return;
  const variantInput = root.querySelector('[data-hs-var-id-input]');
  if (!variantInput || !variantInput.value) {
    const selectVariantText = (form.dataset && form.dataset.selectVariantText) || 'Please select an option.';
    document.dispatchEvent(
      new CustomEvent('hs:cart:item-not-var', {
        detail: selectVariantText,
      }),
    );
    return;
  }

  submitAtcFn(form).then(() => {});
});

// 点击立即购买按钮事件
document.addEventListener('hs:prod:buy:now:click', function(data) {
    if (!data?.detail) return;

    const { buyNowBtn, form } = data.detail;
    if (!buyNowBtn || !form || !(form instanceof HTMLFormElement)) return;

    // 1. 进入 loading 状态
    buyNowBtn.classList.add('active');

    // 2. 收集表单数据
    const formData = new FormData(form);
    const { id: varId, quantity: qty } = Object.fromEntries(formData.entries());

    // 3. 校验参数有效性
    if (varId && qty) {
        const cartUrl = `${localUrl('cart')}/${varId}:${qty}`;
        window.location.href = cartUrl;
    } else {
        console.warn('缺少必要的参数：varId 或 quantity');
        prodPath = form.getAttribute('data-prod-url')
        if (prodPath) {
          window.location.href = prodPath;
        }
    }

    // 4. 兜底：防止跳转失败时按钮一直处于 loading 状态
    setTimeout(() => {
        buyNowBtn.classList.remove('active');
    }, 10000); // 改为 10 秒
});

// --------------------------------------------------------------

// 初始化购物操作
function initShoppingOperation(root) {
  if(!root) return
  initProdImg(root)
  // 监听加入购物车按钮点击事件
  const atcBtns = root.querySelectorAll('[data-hs-atc-button]')
  if (atcBtns.length > 0) {
    atcBtns.forEach(atcBtn => {
      atcBtn.addEventListener('click', e => {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('hs:prod:atc:click', {
              detail: {
                  atcBtn,
                  root
              }
          }))
      });
      bindAtcButtonLoading(atcBtn);
    })
  }

  const buyNowBtns = root.querySelectorAll('[data-hs-buynow-button]')
  if(buyNowBtns.length > 0) {
    buyNowBtns.forEach(buyNowBtn => {
      buyNowBtn.addEventListener('click', e => {
        e.preventDefault();
        const form = root.querySelector('[data-hs-atc-form]')
        if (!form) return;
        document.dispatchEvent(new CustomEvent('hs:prod:buy:now:click', {
            detail: {
                buyNowBtn,
                form
            }
        }))
      })
    })
  }

  // 监听数量盒子事件
  const qtyBoxs = root.querySelectorAll('[data-hs-qty-box]')
  if(qtyBoxs.length > 0) {
      qtyBoxs.forEach(qtyBox => {
          qtyBox.addEventListener('input', e => {
              document.dispatchEvent(new CustomEvent('hs:prod:qty:input', {
                  detail: {
                      eventDom: e.target,
                      root,
                  }
              }))
          })
          qtyBox.addEventListener('click', e => {
              document.dispatchEvent(new CustomEvent('hs:prod:qty:click', {
                  detail: {
                      eventDom: e.target,
                      qtyBox, 
                      root,
                  }
              }))
          })
      })
  }
  
  // 监听变体切换事件
  const variantsCtr = root.querySelector('[data-hs-variants]');
  if (variantsCtr) {
    variantsCtr.addEventListener('change', (event) => {
      const target = event.target;
      if (!target.matches('[data-hs-var-item]')) return;

      const indexAttr = target.getAttribute('data-hs-option-index');
      const changedIndex = indexAttr ? parseInt(indexAttr, 10) : 0;

      const checkedInputs = variantsCtr.querySelectorAll('[data-hs-var-item]:checked');
      if (!checkedInputs || checkedInputs.length === 0) return;

      const selectedData = Array.from(checkedInputs).map((item) => ({
        name: item.getAttribute('name') || null,
        value: item.getAttribute('value') || null,
      }));

      const variantsJsonArr = getVariantsJsonArr(root);
      fixInvalidSelectionsFromIndex(root, variantsJsonArr, changedIndex);

      document.dispatchEvent(
        new CustomEvent('hs:prod:var:option:change', {
          detail: {
            selectedData,
            root,
            changedIndex
          },
        }),
      );
    });

    // 初始化: 默认选中有库存的变体, 并刷新各选项可用状态
    initVariantSelection(root, variantsCtr);
  }
}
// 从某一维开始，自动修正后续维度的无效选中
function fixInvalidSelectionsFromIndex(root, variantsJsonArr, startIndex) {
  if (!root || !Array.isArray(variantsJsonArr) || variantsJsonArr.length === 0) return;

  const firstOptions = variantsJsonArr[0].options;
  const optionCount = Array.isArray(firstOptions) ? firstOptions.length : 0;
  if (optionCount === 0) return;

  // 先基于当前选择刷新可用状态
  refreshVar(null, root);

  // 从 startIndex+1 开始，依次检查每一维
  for (let i = startIndex + 1; i < optionCount; i++) {
    const groupInputs = root.querySelectorAll(`input[data-hs-option-index="${i}"]`);
    if (!groupInputs.length) continue;

    // 当前选中的、且未禁用的
    const checkedValid = Array.from(groupInputs).find(input => input.checked && !input.disabled);

    if (checkedValid) {
      // 如果当前已选仍然可用，就不动
      continue;
    }

    // 选中当前组中第一个未禁用的
    const firstEnabled = Array.from(groupInputs).find(input => !input.disabled);
    if (firstEnabled) {
      firstEnabled.checked = true;
    } else {
      // 全部禁用则清空选中
      groupInputs.forEach(input => { input.checked = false; });
    }

    // 每改动一维，重新刷新可用状态，保证后续逻辑正确
    refreshVar(null, root);
  }
}

// 初始化变体选择: 若当前无有效选择或选中变体缺货, 则默认选中第一个有库存的变体
function initVariantSelection(root, variantsCtr) {
  if (!root) return;
  variantsCtr = variantsCtr || root.querySelector('[data-hs-variants]');
  if (!variantsCtr) return;

  const variantsJsonArr = getVariantsJsonArr(root);
  if (!Array.isArray(variantsJsonArr) || variantsJsonArr.length === 0) return;

  const readSelectedData = () => {
    const checked = variantsCtr.querySelectorAll('[data-hs-var-item]:checked');
    return Array.from(checked).map((item) => ({
      name: item.getAttribute('name') || null,
      value: item.getAttribute('value') || null,
    }));
  };

  const firstOptions = variantsJsonArr[0].options;
  const optionCount = Array.isArray(firstOptions) ? firstOptions.length : 0;

  let selectedData = readSelectedData();
  const selectedComplete =
    selectedData.length === optionCount &&
    selectedData.every((item) => item.value != null);
  // 判断当前选中的组合是否为有库存变体
  let currentVariant = null;
  if (selectedComplete) {
    currentVariant =
      variantsJsonArr.find((variant) =>
        selectedData.every((sel) => variant[sel.name.split('-')[0]] === sel.value)
      ) || null;
  }

  if (!currentVariant || currentVariant.available !== true) {
    const target =
      variantsJsonArr.find((v) => v.available === true) || variantsJsonArr[0];
    if (target && Array.isArray(target.options)) {
      target.options.forEach((val, i) => {
        const inputs = variantsCtr.querySelectorAll(
          `input[data-hs-option-index="${i}"]`
        );
        inputs.forEach((input) => {
          input.checked = input.getAttribute('value') === String(val);
        });
      });
      selectedData = readSelectedData();
    }
  }
  // 触发一次变体变更, 刷新价格 / 提交input / 数量规则 / 选项可用状态
  document.dispatchEvent(
    new CustomEvent('hs:prod:var:option:change', {
      detail: {
        selectedData,
        root,
        changedIndex: -1, // 约定：-1 表示从第 0 维开始全量检查
      },
    })
  );
}

// 绑定加入购物车按钮加载状态
function bindAtcButtonLoading(loadingDom) {
  if (!loadingDom) return;
  if (loadingDom.dataset.hsAtcBinded === 'true') return;
  loadingDom.dataset.hsAtcBinded = 'true';
  
  document.addEventListener('hs:cart:add:start', () => {
    loadingDom.classList.toggle('active', true)
    loadingDom.setAttribute('aria-disabled', 'true');
  });
  document.addEventListener('hs:cart:add:done', () => {
    loadingDom.classList.toggle('active', false)
    loadingDom.setAttribute('aria-disabled', 'false');
  });
}


document.addEventListener('hs:prod:shopping:init', function (event) {
  const { root = null } = event && event.detail;
  if (!root) return;
  initShoppingOperation(root)
});




// 解析购物车数量函数
function parseCartCountSection(data) {
  // 默认数量为 0
  let cartCount = 0;

  if (!data || !data.sections || !data.sections['cart-count']) {
    return cartCount;
  }

  const htmlString = data.sections['cart-count'];
  const doc = parseHtmlString(htmlString);

  if (!doc) {
    return cartCount;
  }

  const countElement = doc.querySelector('[data-cart-count-box]');
  if (!countElement || typeof countElement.textContent !== 'string') {
    return cartCount;
  }

  const text = countElement.textContent.trim();
  const parsed = parseInt(text, 10);

  // 防止 NaN 污染，保持返回 number 类型
  if (!isNaN(parsed)) {
    cartCount = parsed;
  }
  return cartCount;
}

document.addEventListener('hs:cart:add:success', function (event) {
  const { data = null } = event && event.detail;
  if (!data) return;
  const { sections = null } = data || {};
  if (!sections || Object.keys(sections).length === 0) return;
  const html = sections["cart-form-wrap"]|| null;
  if (!html) {
    window.location.href = localUrl('/cart');
    return;
  } else {
    window.hsPushbar.close()
    setTimeout(() => {
      window.hsPushbar.open('right')
      const activeElement = window.hsPushbar.activeElement;
      activeElement.innerHTML = html;
      document.dispatchEvent(new CustomEvent('hs:init:cart', { detail: { root: activeElement } }));
    }, 300)
  }
  const cartCountDom = sections["cart-count"]|| null;
  if (!cartCountDom) return;
  const cartCount = parseCartCountSection(data);
  updateCartIconCount(cartCount);
});








// 点击加购按钮事件
function prodCardBuyFn(item) {
  if (!item) return
  const prodPath = item.getAttribute('data-prod-url')
  if (!prodPath) return
  const targetPathDom = item.querySelector('[data-hs-card-atc]')
  if (!targetPathDom) return
  item.addEventListener('submit', function(event) {
    event.preventDefault()

    const loadingDom = item.querySelector('button[type="submit"]')
    if (!loadingDom) return
    loadingDom.classList.toggle('active', true)
    loadingDom.setAttribute('aria-disabled', 'true');

    fetchSectionFn(prodPath, 'prod-option')
      .then(function(html) {

        if (!html) {
          window.location.href = prodPath
          return
        }
        if (window.hsPushbar) {
          window.hsPushbar.open('right')
          window.hsPushbar.activeElement.innerHTML = html;
          const asideRoot = window.hsPushbar.activeElement
          document.dispatchEvent(new CustomEvent('hs:prod:shopping:init', { detail: { root: asideRoot } }))
        } else {
          window.location.href = prodPath
        }
      })
      .catch(function() {
        window.location.href = prodPath
      }).finally(function() {
        loadingDom.classList.toggle('active', false)
        loadingDom.setAttribute('aria-disabled', 'false');
      })
  })
}

// 点击加购按钮事件
document.addEventListener('hs:prod:card:buy', function(data) {
  if (!data || !data.detail || !data.detail.data) return
  const item = data.detail.data
  if (!item) return
  prodCardBuyFn(item)
})

// 初始化商品图片swiper
function initProdImg(root) {
  if (!root || typeof Swiper === 'undefined') return;

  const thubs = root.querySelectorAll('.hs-pimg__thub')
  const mains = root.querySelectorAll('.hs-pimg__main')

  // 1. 初始化缩略图，存入 Map
  const thumbSwiperMap = new Map()

  thubs.forEach(item => {
      const fullId = item.id // 例如: p-thub-abcd
      const thubSwiper = new Swiper(item, {
          slidesPerView: 'auto',
          freeMode: true,
          watchSlidesProgress: true,
          simulateTouch: true,
          grabCursor: true,
          pagination: {
              clickable: true,
          },
          navigation: {
              nextEl: ".hs-pimg__thub-nav[nav-next=" + fullId + "]",
              prevEl: ".hs-pimg__thub-nav[nav-prev=" + fullId + "]",
          },
      })
      // 以缩略图自己的 ID 为 key 存入
      thumbSwiperMap.set(fullId, thubSwiper)
  })

  // 2. 初始化主图，关联缩略图
  const mainSwiperMap = new Map()
  mains.forEach(item => {
      const mainId = item.id // 例如: p-img-abcd
      
      // 核心改动：把主图 ID 的前缀 'p-img-' 替换成 'p-thub-'，得到对应的缩略图 ID
      const relatedThubId = mainId.replace('p-img-', 'p-thub-')
      
      // 用转换后的 ID 去 Map 里取实例
      const relatedThumbSwiper = thumbSwiperMap.get(relatedThubId)

      const mainSwiper = new Swiper(item, {
          slidesPerView: 1,
          simulateTouch: true,
          grabCursor: true,
          pagination: {
              el: ".hs-pimg__imgnum",
              type: "fraction",
          },
          navigation: {
              nextEl: ".hs-pimg__main-nav[nav-next=" + mainId + "]",
              prevEl: ".hs-pimg__main-nav[nav-prev=" + mainId + "]",
          },
          thumbs: {
              swiper: relatedThumbSwiper,
          },
      })
      // 把主图 Swiper 实例也存起来
      mainSwiperMap.set(mainId, mainSwiper)
  })
  root.mainSwiperMap = mainSwiperMap
}


// 设置变体对应的主图
function setMainProdImage(selectedVariant, root) {
    if (!selectedVariant || !root) return
    // 获取当前产品的主图容器
    const mainEl = root.querySelector('.hs-pimg__main')
    if (!mainEl) return
    
    // 关键修复：先检查 mainSwiperMap 是否存在
    if (!root.mainSwiperMap) {
        console.warn('mainSwiperMap 未初始化，跳过变体切换', root)
        return
    }
    
    // 从 Map 中取出对应的主图 Swiper 实例
    const mainSwiper = root.mainSwiperMap.get(mainEl.id)
    
    // 如果 Map 里没有这个 id 对应的实例，也跳过
    if (!mainSwiper) {
        console.warn('未找到对应的 Swiper 实例', mainEl.id)
        return
    }
    
    const variantImageId = selectedVariant?.featured_image?.id || null
    
    if (variantImageId) {
        // 获取所有 slides
        const slides = mainSwiper.slides
        
        let targetIndex = null
        slides.forEach((slide, index) => {
            // 通过 data-image-id 属性匹配
            if (slide.getAttribute('data-image-id') == variantImageId) {
                targetIndex = index
            }
        })
        
        // 找到对应索引后跳转
        if (targetIndex !== null) {
            mainSwiper.slideTo(targetIndex)
        }
    }
}